<app-language-selector class="language-selector"/>

<div class="card">
    <mat-icon class="lock-icon ct-error-icon-animated">lock</mat-icon>
    <h1>{{ 'shared.not-authorized.title' | translate }}</h1>
    <p>{{ 'shared.not-authorized.message' | translate }}</p>
    <button mat-flat-button color="primary" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        {{ 'shared.not-authorized.back' | translate }}
    </button>
</div>
